if (!customElements.get('phc-product-gift')) customElements.define('phc-product-gift', class extends HTMLElement {
  connectedCallback() {
    this.config = JSON.parse(this.querySelector('[data-pg-config]').textContent);
    this.copy = this.config.copy;
    this.dialog = this.querySelector('dialog');
    this.action = this.querySelector('[data-phcc-gift-continue]');
    this.skip = this.querySelector('[data-phcc-gift-skip]');
    this.err = this.querySelector('[data-phcc-gift-error]');
    this.cartRoot = window.Shopify?.routes?.root || '/';
    this.busy = false;
    this.added = false;
    this.addEventListener('change', () => this.render());
    this.addEventListener('click', event => {
      const b = event.target.closest('button');
      if (!b || this.busy) return;
      if (b.hasAttribute('data-pg-close')) { this.dialog.close(); return; }
      if (b.hasAttribute('data-phcc-gift-continue')) { this.finish(false); return; }
      if (b.hasAttribute('data-phcc-gift-skip')) { this.finish(true); return; }
      if (b.dataset.phccRobeSize) {
        this.querySelectorAll('[data-phcc-robe-size]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        this.querySelectorAll('[data-phcc-robe-group]').forEach(x => x.hidden = x.dataset.phccRobeGroup !== b.dataset.phccRobeSize);
        this.querySelectorAll('[data-phcc-robe-variant]').forEach(x => x.setAttribute('aria-pressed', 'false'));
        this.querySelector('[data-phcc-robe]').value = '';
        this.querySelector('[data-phcc-robe-picked]').textContent = this.copy.robe;
      }
      for (const kind of ['robe', 'accessory']) {
        const id = b.getAttribute('data-phcc-' + kind + '-variant');
        if (!id) continue;
        const select = this.querySelector('[data-phcc-' + kind + ']');
        select.value = id;
        this.querySelectorAll('[data-phcc-' + kind + '-variant]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        if (kind === 'robe') this.querySelector('[data-phcc-robe-picked]').textContent = select.selectedOptions[0].textContent;
      }
      this.render();
    });
    this.dialog.addEventListener('cancel', e => { if (this.busy) e.preventDefault(); });
    this.dialog.addEventListener('close', () => {
      document.body.style.overflow = this.oldOverflow || '';
      this.trigger?.focus({preventScroll:true});
    });
    document.addEventListener('click', e => {
      if (!e.target.closest('[data-phc-product-gift-start]')) return;
      const button = document.querySelector('product-form[data-phc-product-gift] button[name="add"]');
      button?.scrollIntoView({behavior:'smooth',block:'center'});
      button?.click();
    });
  }
  async api(path, body) {
    const r = await fetch(this.cartRoot + path, body ? {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)} : {headers:{'Accept':'application/json'}});
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || this.copy.error);
    return data;
  }
  async openGift(trigger) {
    this.trigger = trigger;
    this.cart = await this.api('cart/update.js', {attributes:{'PHC Product Gift Offers Shown':'Yes'}});
    this.added = false;
    this.querySelector('input[value="none"]').checked = true;
    this.querySelectorAll('select').forEach(x => x.value = '');
    this.querySelectorAll('[data-phcc-accessory-variant],[data-phcc-robe-variant]').forEach(x => x.setAttribute('aria-pressed','false'));
    const picked = this.querySelector('[data-phcc-robe-picked]');
    if (picked) picked.textContent = this.copy.robe;
    this.err.hidden = true;
    this.render();
    this.oldOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.dialog.showModal();
    this.querySelector('.phc-pg-shell').scrollTop = 0;
    this.querySelector('[data-pg-close]').focus({preventScroll:true});
  }
  selection() {
    const kind = this.querySelector('input[name="phcc-gift-choice-product-gift"]:checked')?.value || 'none';
    const select = kind === 'none' ? null : this.querySelector(kind === 'robe' ? '[data-phcc-robe]' : '[data-phcc-accessory]');
    return {kind, id:Number(select?.value || 0), price:Number(select?.selectedOptions[0]?.dataset.price || 0), valid:kind === 'none' || Boolean(select?.value)};
  }
  render() {
    const s = this.selection();
    this.querySelectorAll('[data-phcc-gift-detail]').forEach(x => x.hidden = x.dataset.phccGiftDetail !== s.kind);
    const total = this.querySelector('[data-phcc-extra-total]');
    total.textContent = s.valid && this.cart ? new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.cart.currency || this.config.currency}).format((this.cart.total_price + (this.added ? 0 : s.price))/100) : '—';
    this.action.disabled = this.busy || !s.valid;
    this.skip.disabled = this.busy;
    this.action.textContent = this.busy ? this.copy.saving : !s.valid ? this.copy.choose : s.kind === 'none' ? this.copy.view : this.copy.add;
  }
  async finish(skip) {
    if (this.busy) return;
    const s = this.selection();
    if (!skip && !s.valid) return;
    this.busy = true;
    this.err.hidden = true;
    this.render();
    try {
      if (!skip && s.id && !this.added) {
        const cart = await this.api('cart.js');
        const items = [{id:s.id,quantity:1}];
        if (s.kind === 'robe' && this.config.freeId && !cart.items.some(x => Number(x.variant_id) === this.config.freeId)) items.push({id:this.config.freeId,quantity:1,properties:{Gift:this.copy.giftNote,_PHC_offer:'Royal Treatment'}});
        await this.api('cart/add.js',{items});
        this.added = true;
      }
      window.location.assign(this.cartRoot + 'cart');
    } catch (e) {
      this.err.textContent = e.message || this.copy.error;
      this.err.hidden = false;
      this.busy = false;
      this.render();
    }
  }
});
